module.exports = __webpack_public_path__ + "static/media/parked.3513938c.png";